import Model from "../../Model";
//import { actions } from '@/store';

class salesEvolution extends Model{

    buildUrl ({ param }) {
        return ['sales/evolution', param];
    }
}


export default new salesEvolution;